<template>
  <div class="row">
    <h5 class="col-12 h2 mb-2 mt-4">Referências</h5>
    <h5 class=" col-12 card-title text-uppercase text-muted mb-4 h5">Tabela de referências para rating e score</h5>
    <div class="col-12 mt-3">
      <el-table
        class="table-responsive clickable-rows"
        :border="false"
        :data="references"
        :stripe="false"
      >
        <el-table-column label="Rating" prop="rating" sortable />
        <el-table-column label="SCORE MÍNIMO " prop="minimum_score" sortable v-slot="{ row }">
          {{ row.edit == false ? row.minimum_score.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '' }}
          <div class="row col-4">
            <base-input
              input-classes="form-control-sm"
              wrapper-class="mb-0"
              v-model="row.minimum_score"
              :disabled="row.disable"
              :min="0"
              v-show="row.edit == true"
            ></base-input>
          </div>
        </el-table-column>
        <el-table-column label="SCORE MÁXIMO" prop="maximum_score" sortable  v-slot="{ row }">
          {{ row.edit == false ? row.maximum_score.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ''}}
          <div class="row col-4">
            <base-input
              wrapper-class="mb-0"
              input-classes="form-control-sm"
              v-model="row.maximum_score"
              :disabled="row.disable"
              :min="0"
              v-show="row.edit == true"
            ></base-input>
          </div>
        </el-table-column>
        <el-table-column label="Ações" width="200" v-slot="{ row }">
          <div class="row ml-2">
            <base-button 
              :type="row.edit == false ? 'purple' : 'secondary'" 
              class="mr-2" 
              size="sm" 
              @click="row.edit = !row.edit"
            >
              {{ row.edit == false ? 'Editar' : 'Fechar' }}
            </base-button>
            <base-button type="primary" size="sm" v-show="row.edit == true" @click="row.disable = true, editReference(row)">Salvar</base-button>
          </div>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, } from "element-ui";
export default {
  name: 'references',
  components: {
    [TableColumn.name]: TableColumn,
    [Table.name]: Table,
  },
  data () {
    return {
      references: []
    }
  },
  mounted () {
    this.getReferences()
  },
  methods: {
    async editReference (reference) {
      try {
        await this.$http.secured.put(`/api/v1/credit_analysis/update_references/`, { 
          id: reference.id, 
          maximum_score: reference.maximum_score, 
          minimum_score: reference.minimum_score 
        })
        this.references = this.references.map(reference => ({...reference, edit: false, disable: false}))
        this.$toasted.global.defaultSuccess({msg: 'Referência editada com sucesso!'});          
      } catch (error) {
        console.warn("[References][editReference] ", error)
      }
    },
    getReferences () {
      this.$http.secured.get("/api/v1/credit_analysis/get_references")
        .then((response) => {
          this.references = response.data
          this.references = this.references.map(reference => ({...reference, edit: false, disable: false}))
          console.log('references', this.references)
        })
        .catch((error) => (console.log(error, "Something went wrong")));
    }
  }
}
</script>

<style scoped>
.card-header {
    padding: 1.25rem 1.5rem;
    margin-bottom: 0;
    background-color: #2dce89;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.card {
  box-shadow: 0 0 2rem 0 rgb(136 152 170 / 25%);
}
</style>